import React, { useCallback, useEffect, useState } from 'react'
import Checkbox from '../../../../components/checkbox/Checkbox'
import { AppScrollWrapperNew } from '../../../../widgets/AppScrollWrapper/AppScrollWrapper'
import AppBtn, {
  AppBtnColor,
  AppBtnSize,
  IconPosition,
} from '../../../../components/btn/AppBtn'
import { IBuffetMilletUploadDto } from '../../../../core/api/dto/BuffetMilletDto'
import {
  AppNotification,
  NotificationType,
} from '../../../../components/notification/Notification'
import { useUpdateUploadedBuffetMilletMutation } from '../../../../core/api/BuffetMilletApi'
import moment from 'moment'

interface IConflictsPopupProps {
  setActive: (value: boolean) => void
  conflictData: IBuffetMilletUploadDto
  setLoading: (value: boolean) => void
}
interface ISelectedItems {
  [key: number]: 'old' | 'new'
}
export const ConflictsBlock = ({
  setActive,
  conflictData,
  setLoading,
}: IConflictsPopupProps) => {
  const [selectedItems, setSelectedItems] = useState<ISelectedItems | null>(
    null,
  )
  const [chooseAllOldData, setChooseAllOldData] = useState(false)
  const [chooseAllNewData, setChooseAllNewData] = useState(false)

  const [updateUploadedBuffetMillet, { isLoading }] =
    useUpdateUploadedBuffetMilletMutation()

  const outSideClickHandler = useCallback(() => {
    setActive(false)
  }, [])

  const onChooseItem = (index: number, param: 'old' | 'new') => {
    if (selectedItems && selectedItems[index] === param) return
    setSelectedItems((prev) => ({ ...prev, [index]: param }))
    if (param === 'old' && chooseAllNewData) {
      setChooseAllNewData(false)
    }
    if (param === 'new' && chooseAllOldData) {
      setChooseAllOldData(false)
    }
  }

  useEffect(() => {
    const result: ISelectedItems = {}
    for (let i: number = 0; i < conflictData.conflictMilletsCount; i++) {
      result[i] = 'old'
    }
    setSelectedItems(result)
  }, [])

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  useEffect(() => {
    if (
      !!selectedItems &&
      Object.entries(selectedItems).filter((item) => item[1] === 'old')
        .length === conflictData.conflictMilletsCount &&
      !chooseAllOldData
    ) {
      setChooseAllOldData(true)
    }
    if (
      !!selectedItems &&
      Object.entries(selectedItems).filter((item) => item[1] === 'new')
        .length === conflictData.conflictMilletsCount &&
      !chooseAllNewData
    ) {
      setChooseAllNewData(true)
    }
  }, [selectedItems])

  const onChooseAllItem = (value: boolean, param: 'old' | 'new') => {
    if (value) {
      const result: ISelectedItems = {}
      for (let i: number = 0; i < conflictData.conflictMilletsCount; i++) {
        result[i] = param
      }
      setSelectedItems(result)
      if (param === 'old') {
        setChooseAllOldData(true)
        setChooseAllNewData(false)
      }
      if (param === 'new') {
        setChooseAllOldData(false)
        setChooseAllNewData(true)
      }
      return
    }
    setSelectedItems(null)
    setChooseAllOldData(false)
    setChooseAllNewData(false)
  }

  const saveData = () => {
    if (
      !selectedItems ||
      Object.keys(selectedItems).length < conflictData.conflictMilletsCount
    ) {
      AppNotification({
        msg: 'Для продолжения должны быть отмечены все пункты!',
        type: NotificationType.error,
      })
      return
    }
    const newData = Object.keys(selectedItems).map((param, index) =>
      param === 'old'
        ? conflictData.existingMillets[index]
        : conflictData.uploadedMillets[index],
    )
    updateUploadedBuffetMillet({ data: newData })
      .unwrap()
      .then(() => {
        if (
          selectedItems &&
          Object.entries(selectedItems).filter((item) => item[1] === 'old')
            .length !== conflictData.conflictMilletsCount
        ) {
          AppNotification({
            msg: 'Тары успешно добавлены!',
            type: NotificationType.success,
          })
        }
        setActive(false)
      })
  }
  console.log(conflictData.uploadedMillets)
  return (
    <div className="popup-conflicts">
      <span className="total-conflicts">
        Всего конфликтных данных: {conflictData.conflictMilletsCount}
      </span>
      <small className="bold">Какие данные вы хотите сохранить?</small>
      <span className="description-conflicts">
        Найдено {conflictData.conflictMilletsCount} повторяющихся строк данных.
        Выберете файлы которые необходимо сохранить
      </span>
      <div className="conflicts-checkbox-wrap">
        <div className="conflicts-checkbox-header">
          <Checkbox
            name={'8-pb-all-old'}
            value={chooseAllOldData}
            onChange={(value) => onChooseAllItem(value, 'old')}
            text="Существующие данные"
          />
          <Checkbox
            name={'8-pb-all-new'}
            value={chooseAllNewData}
            onChange={(value) => onChooseAllItem(value, 'new')}
            text="Загружаемые данные"
          />
        </div>
        <div className="conflicts-checkbox-body">
          <AppScrollWrapperNew theme="dropdown">
            {Array.from(
              { length: conflictData.conflictMilletsCount },
              (_, index) => index,
            ).map((item, index) => {
              const existingItem = conflictData.existingMillets[index]
              const newItem = conflictData.uploadedMillets[index]
              return (
                <div className="checkbox-row" key={`conflict-item-${index}`}>
                  <div className="old-data">
                    <Checkbox
                      name={existingItem.guid + 'old'}
                      value={!!selectedItems && selectedItems[index] === 'old'}
                      onChange={() => onChooseItem(index, 'old')}
                      text={existingItem.milletName}
                    />
                    <small>
                      Изменение от{' '}
                      {moment(existingItem.updatedAt).format('DD.MM.YYYY')}
                    </small>
                  </div>
                  <div className="new-data pl-20">
                    <Checkbox
                      name={newItem.guid + 'new'}
                      value={!!selectedItems && selectedItems[index] === 'new'}
                      onChange={() => onChooseItem(index, 'new')}
                      text={newItem.milletName}
                    />
                    <small>
                      Изменение от {moment(new Date()).format('DD.MM.YYYY')}
                    </small>
                  </div>
                </div>
              )
            })}
          </AppScrollWrapperNew>
        </div>
      </div>
      <div className="buttons-block mt-20">
        <AppBtn
          title="Отменить"
          color={AppBtnColor.outlineViolet}
          sized={AppBtnSize.md}
          onClick={outSideClickHandler}
          iconClassName="close"
        />
        <AppBtn
          title="Продолжить"
          color={AppBtnColor.violetWhite}
          sized={AppBtnSize.md}
          onClick={saveData}
          iconClassName="arrow-long"
          iconPosition={IconPosition.right}
        />
      </div>
    </div>
  )
}
